import thdcustomer from '@thd-olt-global/thd-customer';

const discountCodeExistsWithPendingUserId = () => {
  const citiDiscountCode = localStorage.getItem('PLCC_CITI_DC');
  if (!citiDiscountCode) { return null; }
  const localStorageDiscountCode = JSON.parse(citiDiscountCode);
  const userId = localStorageDiscountCode.userId;
  const discountCode = localStorageDiscountCode.discountCode;
  return (userId === 'pending') ? discountCode : null;
};

const getDiscountCode = () => {
  const discountCodeFromCiti = window.document.getElementById('discountCode')
    && window.document.getElementById('discountCode').value;
  if (discountCodeFromCiti) {
    return discountCodeFromCiti;
  }
  if (discountCodeExistsWithPendingUserId()) {
    return discountCodeExistsWithPendingUserId();
  }
  return null;
};

const getExpirationDate30DaysFromNow = () => {
  let date = new Date();
  return date.setDate(date.getDate() + 30);
};

export const addDiscountCodeToLocalStorage = () => {
  const discountCode = getDiscountCode();
  if (discountCode) {
    const citiDiscountCode = {
      discountCode,
      userId: thdcustomer.isLoggedIn ? thdcustomer.userID : 'pending',
      svocId: thdcustomer.isLoggedIn ? thdcustomer.svocID : 'pending',
      expirationDate: getExpirationDate30DaysFromNow(),
    };
    localStorage.setItem('PLCC_CITI_DC', JSON.stringify(citiDiscountCode));
  }
};
